import { baseIntegration } from "./base";
import type { ControlStateIntegration } from "./base";
import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "./constants";
import Banner from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontBanner.svelte";

// Re-export for backward compatibility
export { VT_802_SPIRITS_DISTRIBUTOR_ID };
import Cta from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontCta.svelte";
import CartCta from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontCartCta.svelte";
import PlpCta from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontPlpCta.svelte";
import ActionBar from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontActionBarCta.svelte";
import RetailerUserAuthenticationModalStore from "@retailer/svelte/stores/RetailerUserAuthenticationModalStore";
import { RetailerUserAuthenticationEventEntity } from "@shared/services/event_tracking/entities/retailer_user_authentication_event_entity";
import { EventTracking } from "@shared/services/event_tracking/events";
import AuthenticationModal from "@retailer/svelte/ControlStateUserAuthentication/Vermont/VermontAuthenticationModal.svelte";
import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
import { get } from "svelte/store";

export const vermont: ControlStateIntegration = {
  ...baseIntegration,
  state: "VT",
  text1: "",
  text2: "",
  connectCta: "Verify Account",
  verifyCta: "Verify Account",
  pendingDescription: "Verify your DLL account to order this item.",
  invalidDescription: "Verify your DLL account to order this item.",
  invalidTitle: "We can’t verify your myVermont DLL account.",
  actionBarTitle: "Introducing Vermont DLL",
  actionBarDescription: "Use your myVermont DLL Account to access products from Vermont!",
  loginUrl: () => {
    const returnTo = window.location.pathname + window.location.search;
    const retailerId = get(CurrentRetailerStore).id;
    return `/myvermont?return_to=${returnTo}&retailer_id=${retailerId}`;
  },
  startVerification: (status, attrs = {}) => {
    let entity = new RetailerUserAuthenticationEventEntity({
      distributorId: VT_802_SPIRITS_DISTRIBUTOR_ID,
      ...attrs,
      authenticationStatus: status,
    });
    EventTracking.trackClick("retailer_user_authentication_flow", [entity]);
    RetailerUserAuthenticationModalStore.set({ open: true, distributorId: null });
  },
  bannerComponent: Banner,
  ctaComponent: Cta,
  cartCtaComponent: CartCta,
  plpCtaComponent: PlpCta,
  actionBarCtaComponent: ActionBar,
  authenticationModalComponent: AuthenticationModal,
};
